import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import cx from 'classnames';
import { cloneElement, omitProps } from 'utils/react';
import { itemPropTypes, itemDefaultProps } from '../itemPropTypes';
import styles from '../MenuDropdown.module.scss';

export default class MenuDropdownItem extends Component {
    static displayName = 'MenuDropdownItem';

    static propTypes = {
        ...itemPropTypes,
        innerRef: PropTypes.ref(),
        index: PropTypes.number.isRequired,
        selected: PropTypes.bool,
        highlight: PropTypes.bool,
        isMenuItem: PropTypes.bool,
        onClick: PropTypes.func,
        className: PropTypes.string,
        children: PropTypes.node,
    };

    static defaultProps = {
        ...itemDefaultProps,
        innerRef: null,
        selected: false,
        highlight: false,
        isMenuItem: true,
        onClick: noop,
        className: null,
        children: null,
    };

    handleClick = (event) => {
        const { index, onClick } = this.props;
        onClick(event, index);
    };

    render() {
        const {
            id,
            href,
            disabled,
            selected,
            highlight,
            border,
            control,
            isMenuItem,
            innerRef,
            className,
            children,
        } = this.props;

        const isLink = !!href && !disabled;
        const ItemComponent = isLink ? 'a' : 'button';
        const itemProps = isLink ? { href } : { type: 'button' };
        const classNames = cx(
            'dropdown-item',
            styles.item,
            control && styles.hasControl,
            {
                disabled,
                selected,
                highlight,
                border,
            },
            className,
        );

        return (
            <li role="none" className={styles.menuItem}>
                <ItemComponent
                    {...omitProps(this.props, ['product', 'isMenuItem'], MenuDropdownItem)}
                    {...itemProps}
                    ref={innerRef}
                    id={id}
                    disabled={disabled}
                    className={classNames}
                    role={isMenuItem ? 'menuitem' : 'option'}
                    aria-disabled={disabled}
                    aria-selected={isMenuItem ? null : selected}
                    onClick={this.handleClick}
                >
                    {children}
                    {cloneElement(control, {
                        tag: 'span',
                        className: styles.control,
                        'aria-labelledby': id,
                    })}
                </ItemComponent>
            </li>
        );
    }
}
